import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect, useState } from 'react';

import { AssociateRecalculation } from './associateCalculation/AssociateRecalculation';
import { recalculationProps } from './recalculation-service';
import './recalculation.scss';
import { RecalculationRequestLog } from './recalculationRequestLog/RecalculationRequestLog';
import { useGetRecalculationRequestQuery, useGetScorecardWindowStatusQuery } from './recalculationSlice';
import { ScorecardRecalculation } from './scorecardCalculation/ScorecardRecalculation';

export const Recalculation = (props: recalculationProps) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);

    const { data: scorecardWindowStatus } = useGetScorecardWindowStatusQuery(
        {
            scorecardVersionId: props?.inputScorecardVersion,
            year: props?.inputYear,
            month: props?.inputMonth,
        },
        { skip: !props?.inputScorecardVersion || !props?.inputYear || !props?.inputMonth }
    );

    const { data: recalculationRequest, refetch } = useGetRecalculationRequestQuery(
        {
            scorecardId: scorecardWindowStatus?.data[0]?.scorecard_id,
            year: props?.inputYear,
            month: props?.inputMonth,
            employeenumber: props?.agentNumber ? props?.agentNumber?.toString() : '',
        },
        { skip: !scorecardWindowStatus?.data[0]?.scorecard_id || !props?.inputYear || !props?.inputMonth }
    );

    const headerTemplate = (headerText: string) => {
        return (
            <div className="p-panel-header">
                <span style={{ fontSize: '18px' }}>{headerText}</span>
                <Button
                    label="Refresh"
                    disabled={
                        !scorecardWindowStatus?.data[0]?.scorecard_id ||
                        !props?.inputYear ||
                        !props?.inputMonth
                    }
                    onClick={() => refetch()}
                    className="btn-secondary mb-2 float-end"
                />
            </div>
        );
    };

    useEffect(() => {
        if (activeIndex === 0) {
            props?.recalcutionAssoTab(false);
        } else {
            props?.recalcutionAssoTab(true);
        }
    }, [activeIndex]);

    return (
        <div className="col-md-12">
            <div className="card border-0">
                <div className="card-body border-0">
                    <TabView
                        activeIndex={activeIndex}
                        onTabChange={(e) => {
                            setActiveIndex(e.index);
                        }}
                    >
                        <TabPanel header="Scorecard">
                            <ScorecardRecalculation
                                agentNumber={props?.agentNumber}
                                scoreCardRoleIdValue={props?.scoreCardRoleIdValue}
                                scoreCardWindowStatus={scorecardWindowStatus?.data[0]}
                                inputMonth={props?.inputMonth}
                                inputYear={props?.inputYear}
                            />
                        </TabPanel>                    
                        <TabPanel header="Associate">
                            <AssociateRecalculation
                                agentNumber={props?.agentNumber}
                                agentName={props?.agentName}
                                scoreCardRoleIdValue={props?.scoreCardRoleIdValue}
                                scoreCardWindowStatus={scorecardWindowStatus?.data[0]}
                                inputMonth={props?.inputMonth}
                                inputYear={props?.inputYear}
                            />
                        </TabPanel>
                    </TabView>
                </div>
                <Panel
                    headerTemplate={headerTemplate('Calculation Requests')}
                    className='className="card mt-2 mb-4 ms-4 shadow bg-body rounded border-0"'
                >
                    <RecalculationRequestLog recalculationRequest={recalculationRequest} />
                </Panel>
            </div>
        </div>
    );
};
